var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ height: _vm.topHeight })},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticStyle:{"height":"1px"},style:({ 'border-bottom': _vm.borderBottom })},[_vm._v(" ")]),_vm._v(" "),_c('div',{style:({ height: _vm.bottomHeight })},[_vm._v(" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }